import React from 'react';
import { applySchemeToDocument, useColorScheme } from './useColorScheme';

const ThemeInitializer: React.FC = () => {
  const scheme = useColorScheme((s) => s.scheme);
  React.useEffect(() => {
    applySchemeToDocument(scheme);
  }, [scheme]);
  return null;
};

export default ThemeInitializer;


